/* SIBJ blog post template (v2) */
(function () {
  'use strict';
  var article = document.querySelector('[data-sibj-article]');
  var body = document.querySelector('[data-sibj-body]');
  if (!article || !body) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  /* ---------- 0. Real sticky offset (announcement bar + header) ---------- */
  var headerEl = document.querySelector('.shopify-section--header');
  var stickyTop = 0;
  function measureTop() {
    var t = 0;
    if (headerEl) { var hr = headerEl.getBoundingClientRect(); if (getComputedStyle(headerEl).position === 'sticky' || hr.top <= 0) t = Math.max(0, hr.bottom); }
    if (t !== stickyTop) { stickyTop = t; document.documentElement.style.setProperty('--sibj-top', Math.floor(t) + 'px'); }
  }
  measureTop();

  /* ---------- 1. Reading progress ---------- */
  var bar = document.querySelector('[data-sibj-progress]');
  function progress() {
    if (!bar) return;
    var r = body.getBoundingClientRect();
    var total = r.height - window.innerHeight * 0.6;
    var done = Math.min(Math.max(-r.top, 0), Math.max(total, 1));
    bar.style.width = (total > 0 ? (done / total) * 100 : 0) + '%';
  }

  /* ---------- 2. Table of contents + mobile jump bar ---------- */
  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
  var toc = document.querySelector('[data-sibj-toc]');
  var jump = document.querySelector('[data-sibj-jump]');
  var tocLinks = [];
  var jumpCurrent = document.querySelector('[data-sibj-jump-current]');
  if (heads.length > 1) {
    var used = {};
    heads.forEach(function (h) {
      if (!h.id) {
        var id = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
        while (used[id]) id += '-2';
        used[id] = 1;
        h.id = id;
      }
    });
    var fill = function (list) {
      heads.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
        tocLinks.push(a);
      });
    };
    if (toc) { fill(toc.querySelector('ol')); toc.hidden = false; }
    if (jump) { fill(jump.querySelector('ol')); jump.hidden = false; }

    var scrollToHead = function (h) {
      measureTop();
      var extra = (jump && getComputedStyle(jump).display !== 'none') ? jump.getBoundingClientRect().height + 3 : 0;
      var y = h.getBoundingClientRect().top + window.pageYOffset - stickyTop - extra - 14;
      window.scrollTo({ top: y, behavior: 'smooth' });
    };
    tocLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var h = document.getElementById(a.getAttribute('href').slice(1));
        if (!h) return;
        e.preventDefault();
        if (jump) jump.open = false;
        scrollToHead(h);
        try { history.replaceState(null, '', '#' + h.id); } catch (err) {}
      });
    });
    document.addEventListener('click', function (e) { if (jump && jump.open && !jump.contains(e.target)) jump.open = false; });

  } else {
    if (jump) jump.remove();
  }

  /* Active H2 is the last one above the reading line (sticky offset + jump bar + a little) */
  var activeId = null;
  function updateActiveHead() {
    if (heads.length < 2) return;
    var line = stickyTop + ((jump && getComputedStyle(jump).display !== 'none') ? jump.getBoundingClientRect().height : 0) + 40;
    var cur = null;
    for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top <= line) cur = heads[i]; else break; }
    var id = cur ? cur.id : null;
    if (id === activeId) return;
    activeId = id;
    tocLinks.forEach(function (l) { l.classList.toggle('is-active', !!id && l.getAttribute('href') === '#' + id); });
    if (jumpCurrent) {
      if (cur) { var idx = heads.indexOf(cur); jumpCurrent.textContent = (idx + 1) + '/' + heads.length + '  ' + cur.textContent.trim(); }
      else jumpCurrent.textContent = 'Jump to a section';
    }
  }

  /* ---------- 3. Tables scroll on mobile ---------- */
  body.querySelectorAll('table').forEach(function (t) {
    var cols = t.rows[0] ? t.rows[0].cells.length : 0;
    if (cols > 2) t.setAttribute('data-wide', '');
    if (t.parentElement.classList.contains('sibj-table-scroll')) return;
    var w = document.createElement('div');
    w.className = 'sibj-table-scroll';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* ---------- 4. External links ---------- */
  body.querySelectorAll('a[href^="http"]').forEach(function (a) {
    if (a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noopener'; }
  });

  /* ---------- 5. Product carousels using the theme's own product cards ----------
     Markup: <div class="sibj-products" data-products="handle-a,handle-b" data-title="..." data-collection="/collections/x"></div> */
  var cardCache = {};

  function fetchThemeCard(handle) {
    if (cardCache[handle]) return cardCache[handle];
    cardCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=sibj-product-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var item = doc.querySelector('product-item, .product-item');
        if (!item || item.classList.contains('product-item--sold-out')) return null;
        return item;
      })
      .catch(function () { return null; });
    return cardCache[handle];
  }

  function fallbackCard(handle) {
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.available) return null;
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
        var fmt = function (c) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return '拢' + (c / 100).toFixed(2); } };
        var img = p.featured_image || '';
        if (img.indexOf('//') === 0) img = 'https:' + img;
        var a = document.createElement('a');
        a.className = 'sibj-card';
        a.href = p.url;
        a.innerHTML = '<span class="sibj-card__img-wrap">' + (img ? '<img class="sibj-card__img" loading="lazy" alt="">' : '') + '</span><span class="sibj-card__title"></span><span class="sibj-card__price">' + (p.price_varies ? 'From ' : '') + fmt(p.price) + '</span><span class="button button--primary button--small">Shop now</span>';
        a.querySelector('.sibj-card__title').textContent = p.title;
        if (img) a.querySelector('img').src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=500';
        return a;
      }).catch(function () { return null; });
  }

  function buildCarousel(box) {
    var handles = (box.getAttribute('data-products') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!handles.length) { box.remove(); return; }
    var title = box.getAttribute('data-title');
    var collection = box.getAttribute('data-collection');
    var head = document.createElement('div');
    head.className = 'sibj-products__head';
    head.innerHTML = '<p class="sibj-products__title"></p><div class="sibj-products__tools">' + (collection ? '<a class="sibj-products__link" href=""></a>' : '') + '<span class="sibj-products__nav" hidden><button type="button" class="sibj-products__arrow" data-dir="-1" aria-label="Previous"><svg width="17" height="14" viewBox="0 0 17 14" fill="none"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2"/></svg></button><button type="button" class="sibj-products__arrow" data-dir="1" aria-label="Next"><svg width="17" height="14" viewBox="0 0 17 14" fill="none"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2"/></svg></button></span></div>';
    head.querySelector('.sibj-products__title').textContent = title || 'Shop the look';
    if (collection) { var vl = head.querySelector('.sibj-products__link'); vl.href = collection; vl.textContent = box.getAttribute('data-collection-text') || 'View all'; }
    var list = document.createElement('product-list');
    list.className = 'product-list';
    list.innerHTML = '<div class="scroller"><div class="product-list__inner product-list__inner--scroller hide-scrollbar"></div></div>';
    var inner = list.querySelector('.product-list__inner');
    box.appendChild(head);
    box.appendChild(list);

    Promise.all(handles.map(function (h) {
      return fetchThemeCard(h).then(function (card) { return card ? card.cloneNode(true) : fallbackCard(h); });
    })).then(function (cards) {
      var shown = 0;
      cards.forEach(function (c) { if (c) { var qf = c.querySelector('.product-item__quick-form'); if (qf) qf.remove(); inner.appendChild(c); shown++; } });
      if (!shown) { box.remove(); return; }
      var nav = head.querySelector('.sibj-products__nav');
      var arrows = nav.querySelectorAll('.sibj-products__arrow');
      function syncArrows() {
        var canScroll = inner.scrollWidth > inner.clientWidth + 4;
        nav.hidden = !canScroll;
        arrows[0].disabled = inner.scrollLeft <= 2;
        arrows[1].disabled = inner.scrollLeft + inner.clientWidth >= inner.scrollWidth - 2;
      }
      arrows.forEach(function (b) {
        b.addEventListener('click', function () {
          var card = inner.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : inner.clientWidth * 0.8;
          inner.scrollBy({ left: step * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
        });
      });
      inner.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      setTimeout(syncArrows, 50);
      box.classList.add('is-ready');
    });
  }
  body.querySelectorAll('.sibj-products[data-products]').forEach(buildCarousel);

  /* ---------- 6. Mid-article CTA (after the 2nd H2, or where <div data-sibj-cta></div> is placed) ---------- */
  var midTpl = document.querySelector('[data-sibj-cta-mid]');
  if (midTpl) {
    var slots = body.querySelectorAll('[data-sibj-cta]');
    if (slots.length) {
      slots.forEach(function (s) { s.replaceWith(midTpl.content.cloneNode(true)); });
    } else if (heads.length >= 3) {
      var target = heads[Math.min(2, heads.length - 1)];
      target.parentNode.insertBefore(midTpl.content.cloneNode(true), target);
    }
  }

  /* ---------- 6b. Dynamic shop target: sticky bar + TOC button follow the section being read ---------- */
  var updateShopTarget = null;
  var shopLinks = document.querySelectorAll('[data-sibj-shop-link]');
  var shopBoxes = document.querySelectorAll('[data-sibj-shop-box]');
  var stickyEl = document.querySelector('[data-sibj-sticky]');
  if (shopLinks.length && stickyEl) {
    var defaultTarget = { url: stickyEl.getAttribute('data-default-url'), title: stickyEl.getAttribute('data-default-title'), img: stickyEl.getAttribute('data-default-img'), kind: 'collection' };
    var targetCache = {};
    var currentTargetKey = '';

    var resolveTarget = function (href) {
      if (targetCache[href]) return targetCache[href];
      var m;
      var pr;
      if ((m = href.match(/\/products\/([a-z0-9-]+)/))) {
        pr = fetch(root + 'products/' + m[1] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p || !p.available) return null;
          var img = p.featured_image || '';
          if (img.indexOf('//') === 0) img = 'https:' + img;
          return { url: p.url, title: p.title, img: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '', kind: 'product' };
        });
      } else if ((m = href.match(/\/collections\/([a-z0-9-]+)(?:\/([a-z0-9-]+))?/))) {
        /* /collections/a/b is a tag-filtered page: prefer a real collection called b, else fall back to a (keeping the original link) */
        var fetchCol = function (handle) {
          return fetch(root + 'collections/' + handle + '?section_id=sibj-collection-card').then(function (r) { return r.ok ? r.text() : null; }).then(function (html) {
            if (!html) return null;
            var d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sibj-collection]');
            if (!d) return null;
            return { url: d.getAttribute('data-url'), title: d.getAttribute('data-title'), img: d.getAttribute('data-image'), kind: 'collection' };
          });
        };
        pr = (m[2] ? fetchCol(m[2]) : Promise.resolve(null)).then(function (t) {
          if (t) return t;
          return fetchCol(m[1]).then(function (t2) { if (t2 && m[2]) t2.url = href; return t2; });
        });
      } else {
        pr = Promise.resolve(null);
      }
      targetCache[href] = pr.catch(function () { return null; });
      return targetCache[href];
    };

    /* Build a section 鈫� href map from H2/H3 boundaries. Authors can force one with data-shop="/collections/x" on a heading. */
    var sectionHeads = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
    var sectionHref = {};
    /* Walk the body in document order: the first shoppable link/carousel after each heading belongs to that heading. */
    (function () {
      var cur = -1, lastH2 = -1, prod = {};
      var all = body.querySelectorAll('*');
      for (var k = 0; k < all.length; k++) {
        var el = all[k];
        var hi = sectionHeads.indexOf(el);
        if (hi > -1) {
          if (el.tagName === 'H2') { cur = hi; lastH2 = hi; }
          else if (el.getAttribute('data-shop')) { cur = hi; }
          else { cur = lastH2; } /* plain H3s share their H2's target */
          if (el.getAttribute('data-shop')) sectionHref[hi] = el.getAttribute('data-shop');
          continue;
        }
        if (cur < 0 || sectionHref[cur]) continue;
        if (el.matches('.sibj-products[data-collection]')) { sectionHref[cur] = el.getAttribute('data-collection'); continue; }
        if (el.closest('.sibj-cta, .product-item')) continue;
        if (el.matches('a[href*="/collections/"]')) { sectionHref[cur] = el.getAttribute('href'); continue; }
        if (el.matches('a[href*="/products/"]') && !prod[cur]) prod[cur] = el.getAttribute('href');
      }
      for (var key in prod) { if (!sectionHref[key]) sectionHref[key] = prod[key]; }
    })();

    var applyTarget = function (t) {
      var key = t.url;
      if (key === currentTargetKey) return;
      currentTargetKey = key;
      shopBoxes.forEach(function (b) { b.classList.add('is-swapping'); });
      setTimeout(function () {
        shopLinks.forEach(function (l) { l.href = t.url; });
        document.querySelectorAll('[data-sibj-shop-img]').forEach(function (img) { if (t.img) { img.src = t.img; img.style.visibility = ''; } else { img.style.visibility = 'hidden'; } });
        document.querySelectorAll('[data-sibj-shop-title]').forEach(function (x) { x.textContent = t.title; });
        document.querySelectorAll('[data-sibj-shop-kicker]').forEach(function (x) { x.textContent = t.kind === 'product' ? 'Mentioned in this section' : 'Shop the range'; });
        shopBoxes.forEach(function (b) { b.classList.remove('is-swapping'); });
      }, 220);
    };

    var lastSection = -2, seq = 0;
    updateShopTarget = function () {
      var line = stickyTop + window.innerHeight * 0.35;
      var cur = -1;
      for (var k = 0; k < sectionHeads.length; k++) { if (sectionHeads[k].getBoundingClientRect().top <= line) cur = k; else break; }
      if (cur === lastSection) return;
      lastSection = cur;
      /* an H3 with no target falls back to its parent H2's target, then the post default */
      var i = cur, href = null;
      if (i >= 0) { href = sectionHref[i]; if (!href) { while (i >= 0 && sectionHeads[i].tagName !== 'H2') i--; if (i >= 0) href = sectionHref[i]; } }
      var my = ++seq;
      if (!href) { applyTarget(defaultTarget); return; }
      resolveTarget(href).then(function (t) { if (my === seq) applyTarget(t || defaultTarget); });
    };
  }

  /* ---------- 7. Sticky mobile CTA ---------- */
  var sticky = document.querySelector('[data-sibj-sticky]');
  var stickyDismissed = false;
  try { stickyDismissed = sessionStorage.getItem('sibjStickyClosed') === '1'; } catch (e) {}
  if (sticky && !stickyDismissed) {
    sticky.hidden = false;
    var close = sticky.querySelector('[data-sibj-sticky-close]');
    close.addEventListener('click', function () {
      sticky.classList.remove('is-visible');
      stickyDismissed = true;
      try { sessionStorage.setItem('sibjStickyClosed', '1'); } catch (e) {}
    });
  }
  function stickyUpdate() {
    if (!sticky || stickyDismissed) return;
    var r = body.getBoundingClientRect();
    var past = -r.top > window.innerHeight * 0.9;
    var nearEnd = r.bottom < window.innerHeight * 0.5;
    sticky.classList.toggle('is-visible', past && !nearEnd);
  }

  /* ---------- 8. Share ---------- */
  var share = document.querySelector('[data-sibj-share]');
  function toast(msg) {
    var t = document.querySelector('.sibj-toast');
    if (!t) { t = document.createElement('div'); t.className = 'sibj-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }
  if (share) {
    share.addEventListener('click', function () {
      var url = share.getAttribute('data-url'), title = share.getAttribute('data-title');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
      } else {
        window.prompt('Copy this link', url);
      }
    });
  }

  /* ---------- 8b. Newsletter (Klaviyo client API) ---------- */
  var nl = document.querySelector('[data-sibj-newsletter]');
  if (nl) {
    nl.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = nl.querySelector('input[type="email"]');
      var msg = nl.querySelector('[data-sibj-newsletter-msg]');
      var btn = nl.querySelector('button');
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; input.focus(); return; }
      btn.disabled = true; msg.textContent = '';
      var payload = { data: { type: 'subscription', attributes: { custom_source: 'Blog post', profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Blog signup page': location.pathname } } } } }, relationships: { list: { data: { type: 'list', id: nl.getAttribute('data-list') } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(nl.getAttribute('data-company')), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.status === 202 || r.ok) { nl.classList.add('is-done'); msg.textContent = 'You\'re in. Check your inbox to confirm.'; input.value = ''; }
        else { msg.textContent = 'Something went wrong, please try again.'; btn.disabled = false; }
      }).catch(function () { msg.textContent = 'Something went wrong, please try again.'; btn.disabled = false; });
    });
  }

  /* ---------- 9. Was this helpful ---------- */
  var helpful = document.querySelector('[data-sibj-helpful]');
  if (helpful) {
    var key = 'sibjHelpful-' + helpful.getAttribute('data-article');
    var prev = null;
    try { prev = localStorage.getItem(key); } catch (e) {}
    if (prev) {
      var b = helpful.querySelector('[data-vote="' + prev + '"]');
      if (b) b.classList.add('is-active');
    }
    helpful.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vote]');
      if (!btn) return;
      var vote = btn.getAttribute('data-vote');
      helpful.querySelectorAll('[data-vote]').forEach(function (x) { x.classList.toggle('is-active', x === btn); });
      helpful.querySelector('.sibj-helpful__thanks').hidden = false;
      try { localStorage.setItem(key, vote); } catch (err) {}
      var hook = article.getAttribute('data-helpful-webhook');
      if (hook) {
        try {
          fetch(hook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ article: helpful.getAttribute('data-article'), url: location.pathname, vote: vote, ts: Date.now() }) });
        } catch (err) {}
      }
    });
  }

  /* ---------- scroll loop ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    raf(function () { measureTop(); progress(); stickyUpdate(); updateActiveHead(); if (updateShopTarget) updateShopTarget(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();